import { jsx as _jsx } from "react/jsx-runtime";
import React from 'react';
import styled from 'styled-components';
const Stack = ({ children, className }) => _jsx(Container, { className: className, children: children });
const Container = styled.div `
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
`;
export default Stack;
